<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Grupos</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear grupo</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-2" description="Ejemplo: Cuarto A">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del grupo"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="input-group-2" label="Grado:" label-for="input-2" description="Seleccione el grado al que pertenece el grupo">
                <b-form-select v-model="form.gradeSelected" :options="grades"></b-form-select>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="col-md-6">
          <b-form-group label="Buscar grupo:" label-for="input-search-group" description="Ejemplo: Cuarto A">
            <b-form-input id="input-search-group" v-model="form.searchGroup" placeholder="Ingrese el nombre del grupo" />
          </b-form-group>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de grupos</strong>
            </h5>
          </div>
          <div class="col offset-6" style="margin-top: -4px;">
            <b-button squared variant="outline-primary" class="btn-rounded" v-on:click="openModalEnrollment()">
              <i class="fa fa-address-card mr-1" style="margin-top: -2px;"></i>
              Descargar ficha de matricula total
            </b-button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-table id="table-groups" striped hover
            :fields="columns" :items="filteredData" :per-page="pagination.perPage"
            :current-page="pagination.currentPage"
            head-variant="light" responsive>
              <template #cell(actions)="data">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Editar grupo</span>
                  </template>
                  <button type="button" @click="openModal(data.item)" class="btn btn-light ml-3">
                    <i class="fa fa-edit text-blue"/>
                  </button>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Carga académica</span>
                  </template>
                  <button type="button" @click="openLoadAcademic(data.item.id)" class="btn btn-light ml-3">
                    <i class="fa fa-wrench text-blue"/>
                  </button>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Descargar ficha de Matrícula</span>
                  </template>
                  <button type="button" @click="downloadEnrollmentSheet(data.item, null)" class="btn btn-light ml-3">
                    <i class="fa fa-address-card-o text-blue"/>
                  </button>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Eliminar grupo</span>
                  </template>
                  <button type="button" @click="deleteGroup(data.item)" class="btn btn-light ml-3">
                    <i class="fa fa-trash text-red"/>
                  </button>
                </a-tooltip>
              </template>
            </b-table>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="filteredData.length"
              :per-page="pagination.perPage"
              align="right"
              aria-controls="table-groups"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-group" ref="modal" title="Editar grupo" hide-footer>
      <b-form @submit="edit" ref="todoform">
        <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-2" description="Ejemplo: Cuarto A">
          <b-form-input id="input-1-edit" v-model="groupToEdit.name" required placeholder="Ingrese el nombre del grupo"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2-edit" label="Grado:" label-for="input-2" description="Seleccione el grado al que pertenece el grupo">
          <b-form-select v-model="groupToEdit.idGrade" :options="grades"></b-form-select>
        </b-form-group>
        <b-button @click="$bvModal.hide('edit-group')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
    <b-modal id="enrollmentSheet" ref="modal" title="Ficha de matricula por año" hide-footer size="sm">
      <b-row>
        <b-col sm="2">
          <label style="margin-top: 0.4em;">Año: </label>
        </b-col>
        <b-col>
          <b-form>
            <b-form-group description="Seleccione el año">
              <b-form-select id="year-select" v-model="yearSelection" :options="yearOptions"></b-form-select>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="5">
          <b-button @click="$bvModal.hide('enrollmentSheet')" variant="secondary" size="sm" class="mb-3 mt-3">Cancelar</b-button>
          <b-button @click="downloadEnrollmentSheet(null, yearSelection)" variant="primary">Guardar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import axios from 'axios'
import store from 'store'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import moment from 'moment'
import { showErrorMessage } from '@/services/utilities'

const columns = [
  { label: 'Código', dataIndex: 'id', key: 'value' },
  { label: 'Grupo', dataIndex: 'name', key: 'text' },
  { label: 'Grado', dataIndex: 'textIdGrade', key: 'grade.name' },
  { label: 'Acción', dataIndex: 'actions', key: 'actions', thClass: 'text-center', tdClass: 'text-center' },
]

export default {
  name: 'ManagementGrade',
  data() {
    return {
      yearOptions: [],
      yearSelection: null,
      item: '',
      accessToken: '',
      form: {
        name: '',
        gradeSelected: null,
        searchGroup: '',
      },
      groupToEdit: {
        name: '',
        gradeSelected: null,
      },
      data: null,
      columns,
      grades: null,
      pagination: {
        perPage: 10,
        currentPage: 1,
      },
    }
  },
  watch: {
    'pagination.currentPage': function (newValue) {
      this.$cookies.set('groupsCurrentPage', newValue)
    },
  },
  computed: {
    ...mapState(['user']),
    filteredData() {
      if (!this.data) return []
      if (!this.form.searchGroup) return this.data

      const normalizeString = (string) => string.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

      const searchGroup = normalizeString(this.form.searchGroup)
      return this.data.filter(row => normalizeString(row.name).includes(searchGroup))
    },
  },
  beforeRouteEnter (to, from, next) {
    const userStorage = JSON.parse(store.get('userData'))

    function getGrades() {
      return apiClient.get('/grades')
    }

    function getGroups() {
      return apiClient.get('/groups', {
        params: {
          idSchool: userStorage.idSchool,
          idYear: userStorage.currentYear,
        },
      })
    }
    axios.all([getGrades(), getGroups()])
      .then(axios.spread(function (grades, groups) {
        next((vm) => {
          const gradesData = grades.data.results.rows.map(x => {
            return {
              value: x.id,
              text: x.id + ' - ' + x.name,
            }
          })
          gradesData.unshift({ value: null, text: 'Seleccione un grado' })
          const groupsData = groups.data.map(x => {
            x.textIdGrade = x.idGrade + ' - ' + x.grade.name
            x.text = x.name
            x.value = x.id
            return x
          })
          vm.setDataGrades(null, gradesData)
          vm.setDataGroups(null, groupsData)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataGrades(err, [])
          vm.setDataGroups(err, [])
        })
      })
  },
  methods: {
    setDataGrades (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.grades = data
      }
    },
    setDataGroups (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.data = data
        this.pagination.rows = data.length

        setTimeout(() => {
          this.pagination.currentPage = this.$cookies.get('groupsCurrentPage') || 1
        }, 100)
      }
    },
    save(evt) { // Guarda un grupo llamando a la API
      evt.preventDefault()
      this.form.idSchool = this.$store.state.user.idSchool
      this.form.idYear = this.$store.state.user.currentYear
      this.form.idGrade = this.form.gradeSelected
      apiClient.post('/groups', this.form).then(response => {
        response.data.textIdGrade = response.data.idGrade + ' - ' + response.data.grade
        this.data.push(response.data)
        this.form.name = ''
        this.form.gradeSelected = null
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `El grupo ${response.data.name} fue creado con éxito.`,
        })
        this.search()
      }).catch(err => {
        this.$notification.error({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    openModal(groupIn) { // Abre el modal para editar el grupo
      // groupIn.value = groupIn.idGrade
      this.groupToEdit = Object.assign({}, groupIn)
      this.$bvModal.show('edit-group')
    },
    openModalEnrollment () {
      apiClient.get('/years').then(response => {
        this.yearOptions = response.data.map(x => {
          return {
            value: x.id,
            text: x.name,
          }
        })
        this.yearOptions.unshift({ value: null, text: 'Seleccione un año' })
        this.$bvModal.show('enrollmentSheet')
      }).catch(e => {
        Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
      })
    },
    edit(evt) { // Edita un grupo llamando a la API
      evt.preventDefault()
      apiClient.patch(`/groups/${this.groupToEdit.id}`, this.groupToEdit).then(response => {
        this.data = this.data.map(x => {
          if (x.id === response.data.id) {
            response.data.textIdGrade = response.data.idGrade + ' - ' + response.data.grade
            this.search()
            return response.data
          } else {
            return x
          }
        })
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el grupo ${response.data.name} correctamente.`,
        })
        this.$bvModal.hide('edit-group')
      }).catch(err => {
        this.$notification.error({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    async search() {
      const userStorage = JSON.parse(store.get('userData'))
      await apiClient.get('/groups', {
        params: {
          idSchool: userStorage.idSchool,
          idYear: userStorage.currentYear,
        },
      }).then(response => {
        const groupsData = response.data.map(x => {
          x.textIdGrade = x.idGrade + ' - ' + x.grade.name
          x.text = x.name
          x.value = x.id
          return x
        })
        this.data = groupsData
        this.pagination.rows = groupsData.length
      }).catch(e => {
        Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
      })
    },
    downloadEnrollmentSheet(group, year) {
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      let url = ''
      if (year) {
        url = process.env.VUE_APP_API_URL + '/enrollments/enrollment-sheet/report?isGroup=false&currentYear=false&yearSelected=' + this.yearSelection
      } else {
        url = process.env.VUE_APP_API_URL + '/enrollments/enrollment-sheet/report?isGroup=true&idGroup=' + group.id + '&currentYear=true'
      }
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let name = ''
        if (group === null) {
          for (const year of this.yearOptions) {
            if (year.value === this.yearSelection) {
              name = `Ficha_de_Matricula_${year.text}.pdf`
            }
          }
        } else {
          name = `Ficha_de_Matricula_${group.name}_${endNameReport}.pdf`
        }
        link.href = url
        link.setAttribute('download', name) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    deleteGroup(group) {
      Swal.fire({
        title: 'Confirmar eliminación del grupo',
        text: '¿Desea eliminar el grupo ' + group.name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient.delete('/groups/' + group.id).then(response => {
            Swal.fire('Grupo eliminado con éxito', '', 'success')
            this.search()
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        }
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
    },
    openLoadAcademic(idGroup) {
      this.$router.push({ name: 'settingsLoadAcademic', params: { idGroup: idGroup } })
    },
  },
  created() {
    this.accessToken = store.get('accessToken')
  },
}
</script>
